import { render, staticRenderFns } from "./SidebarNavGroup.vue?vue&type=template&id=19ae0872&scoped=true"
import script from "./SidebarNavGroup.vue?vue&type=script&lang=js"
export * from "./SidebarNavGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavGroup.vue?vue&type=style&index=0&id=19ae0872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae0872",
  null
  
)

export default component.exports